import { Grid, Theme, useMediaQuery, Drawer, IconButton, useTheme } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import NavigationList from './NavigationList';
import { TenantAccount } from '../gql-types.generated';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawerPaper: {
      zIndex: 0,
      marginTop: '64px',
      height: 'calc(100% - 64px)',
    },
    closeIcon: {
      position: 'fixed',
      color: '#ffffff',
      marginLeft: '310px',
      marginTop: theme.spacing(3),
    },
    iconSize: {
      fontSize: '1.8em',
    },
    mainGrid: {
      paddingTop: 64,
      width: 310,
      [theme.breakpoints.up('md')]: {
        paddingTop: 0,
      },
    },
  }),
);

interface TenantMenuProps {
  isMenuOpen: boolean;
  handleMenuClose: () => void;
  tenantAccount?: TenantAccount;
  showStatements: boolean;
  showPayoutReports: boolean;
  restrictedToUserManagement?: boolean;
}
const TenantMenu: React.FC<TenantMenuProps> = props => {
  const { isMenuOpen, handleMenuClose, tenantAccount, showStatements, showPayoutReports, restrictedToUserManagement } = props;
  const classes = useStyles();
  const theme = useTheme();
  const matchesMdDown = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Drawer
      open={isMenuOpen}
      variant={matchesMdDown ? 'temporary' : 'persistent'}
      anchor="left"
      classes={{
        paper: matchesMdDown ? '' : classes.drawerPaper,
      }}
      data-cy="tenant-menu"
      id="tenant-menu"
    >
      <Grid className={classes.mainGrid}>
        {matchesMdDown && isMenuOpen && (
          <IconButton className={classes.closeIcon} onClick={handleMenuClose} data-cy="settings-menu-close" size="large">
            <CloseIcon className={classes.iconSize} />
          </IconButton>
        )}
        <Grid container>
          <NavigationList
            tenantAccount={tenantAccount}
            showStatements={showStatements}
            showPayoutReports={showPayoutReports}
            restrictedToUserManagement={restrictedToUserManagement}
          />
        </Grid>
      </Grid>
    </Drawer>
  );
};

export default TenantMenu;
